export const LOAD_BLACK_LIST_USERS = 'LOAD_BLACK_LIST';
export const ADD_BLACK_LIST_USER = 'ADD_BLACK_LIST_USER';
export const DELETE_BLACK_LIST_USER = 'DELETE_BLACK_LIST_USER';
export const LOAD_BLACK_LIST_REQUISITES = 'LOAD_BLACK_LIST_REQUISITES';
export const ADD_BLACK_LIST_REQUISITE = 'ADD_BLACK_LIST_REQUISITE';
export const DELETE_BLACK_LIST_REQUISITE = 'DELETE_BLACK_LIST_REQUISITE';
export const LOAD_EXCHANGE_SETTINGS = 'LOAD_EXCHANGE_SETTINGS';
export const EDIT_EXCHANGE_SETTINGS = 'EDIT_EXCHANGE_SETTINGS';
export const ADD_USER_NOTE = 'ADD_USER_NOTE';
export const DELETE_USER_NOTE = 'DELETE_USER_NOTE';
